import { render, staticRenderFns } from "./ProductImage.vue?vue&type=template&id=47c5e9a8&"
import script from "./ProductImage.vue?vue&type=script&lang=js&"
export * from "./ProductImage.vue?vue&type=script&lang=js&"
import style0 from "./ProductImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports